const mediaNameComposition = {
  productCode: 'código da referência (produto)',
  productName: 'nome do produto (livre)',
  colorCode: 'código da cor',
  photoOrder: 'ordem da foto',
};

export default mediaNameComposition;
